import { FC } from 'react';

import { Icon } from '../../../@paco/components';
import { IconButton } from '../../../@paco/compositions';
import { Comment } from '../../../@paco/entities/Comment/Comment';
import trans from '../../../@paco/helpers/trans';
import { getUserFullName } from '../../../helpers';
import { CommentViewModel } from '../../../models';
import UserPageLink from '../../UserPageLink/UserPageLink';

import './PlannedUserComments.scss';

interface PlannedUserCommentsProps {
    comments: (CommentViewModel | Comment)[];
    isEditable?: boolean;
    onDeleteComment?: (comment: CommentViewModel | Comment) => void;
    className?: string;
}

export const PlannedUserComments: FC<PlannedUserCommentsProps> = ({
    comments,
    isEditable,
    onDeleteComment,
    className = '',
}) => (
    <ul className={`planned-user-comments ${isEditable ? 'planned-user-comments--is-editable' : ''} ${className}`}>
        {comments.filter((comment) => !! (comment.owner && comment.body))
            .map((comment, i) => (
                <li key={i} className="planned-user-comments__comment">
                    <Icon name="comment-text-outline" className="planned-user-comments__comment-icon" />
                    <div className="planned-user-comments__comment-content">
                        <div className="planned-user-comments__comment-text">
                            <UserPageLink
                                name={`${getUserFullName(comment.owner)}:`}
                                id={comment.owner?.id}
                                className="planned-user-comments__comment-owner"
                            />
                            <span className="planned-user-comments__comment-body">{comment.body}</span>
                        </div>
                        {isEditable && onDeleteComment && (
                            <IconButton
                                hideLabel
                                icon="trash"
                                text={trans('common.delete')}
                                className="planned-user-comments__comment-delete-button"
                                iconClassName="planned-user-comments__comment-delete-button-icon"
                                onClick={() => onDeleteComment(comment)}
                            />
                        )}
                    </div>
                </li>
            ))}
    </ul>
);

